<template>
  <div class="">
    <template v-for="(item, index) in pqcList" :key="index">
      <a-space>
        <div
          :class="[!selectSubOrdinateList ? 'unsubOrdinate' : 'subOrdinate']"
        >
          {{ item.snNumber }}
        </div>

        <div>
          <template v-for="(subOrdinate, index) in selectSubOrdinateList">
            <subordinate
              :produceOrTpc="props.produceOrTpc"
              :modelSpecifications="item.modelSpecifications"
              :type="subOrdinate"
              :superior="item"
            >
            </subordinate>
          </template>
        </div>
      </a-space>
    </template>
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";

import subordinate from "@/views/productDaily/components/instruction/compnents/subordinate.vue";

export default defineComponent({
  props: {
    superior: Object,
    produceOrTpc: String,
  },
  components: {
    subordinate,
  },
  setup(props, context) {
    // 工序流程
    const processFlow = [
      {
        step: "threeMajorItems",
        superiorProcess: [
          "fixedbase",
          "sportsBase",
          "handle",
        ],
      },
      {
        step: "girdling",
        superiorProcess: null,
      },
      {
        step: "detector",
        superiorProcess: null,
      },
      {
        step: "referenceArm",
        superiorProcess: ["girdling"],
      },
      {
        step: "fiberOpticReferenceArm",
        superiorProcess: ["referenceArm"],
      },
      {
        step: "completeReferenceArm",
        superiorProcess: [
          "threeMajorItems",
          "fiberOpticReferenceArm",
          "detector",
        ],
      },
      {
        step: "calibrate",
        superiorProcess: ["completeReferenceArm"],
      },
      {
        step: "assembleDebug",
        superiorProcess: ["calibrate"],
      },
      {
        step: "fqc",
        superiorProcess: ["assembleDebug"],
      },
    ];

    // 对应的上级工序流程
    const selectSubOrdinateList = computed(() => {
      if (props.superior && props.superior.productName) {
        const productName = props.superior.productName;

        const subOrdinate = processFlow.find((f) => f.step === productName);

        if (!subOrdinate) return null;

        return subOrdinate.superiorProcess;
      }

      return [];
    });

    // 产品编号
    const pqcList = computed(() => {
      if (props.superior && props.superior.pqcList) {
        return props.superior.pqcList;
      }
      return [];
    });

    return {
      props,
      pqcList,
      selectSubOrdinateList,
    };
  },
});
</script>

<style lang="less" scoped>
:deep(.ant-space-align-center) {
  padding: 2px;
  background: #efefef;
  border-radius: 5px;
  margin-bottom: 5px;
}
.subOrdinate {
  width: 170px;
}
.unsubOrdinate {
  width: 420px;
  text-align: left;
  padding: 5px 0 5px 10px;
}
</style>
